import View from './View';

class Router{
    constructor(){
        this.registred_routes = [];
        this.base_path = '';
        this.current_route = false;
    }

    match( pattern ){
        let RouteObject = new Route( pattern );
        this.registred_routes.push( RouteObject );

        return RouteObject
    }

    resolve( link ){
        let pathname = link.pathname;
        this.current_route = false;
        if( this.base_path && pathname.indexOf( this.base_path ) == 0 ){
            pathname = pathname.slice( this.base_path.length );
        }

        if( pathname[ 0 ] != "/" ){
            pathname = "/" + pathname;
        }

        for( let i = 0; i < this.registred_routes.length; i++ ){
            let route = this.registred_routes[ i ];

            if( route.test( pathname ) ){
                this.current_route = route;
                break;
            }
        }
    }
}

class Route{
    constructor( pattern ){
        this._pattern = pattern;
        this._a_pattern = pattern.split( /\/+/ ).filter( e => e);
        this._conditions = {};
        this._view = false;
    }

    conditions( conditions_list ){
        $.extend( this._conditions, conditions_list );
        return this;
    }

    setView( view ){
        this._view = view;
        return this;
    }

    get view(){
        return this._view || View;
    }

    test( pathname ){
        let a_pathname = pathname.split( /\/+/ ).filter( e => e ),
            params = {};

        // If both array are not the same length, can't be good...
        if( a_pathname.length !== this._a_pattern.length ) return false;

        // Check each part individually
        for( let i = 0; i < a_pathname.length; i++ ){
            let c_part = a_pathname[ i ],
                part_to_match = this._a_pattern[ i ];

            // If both part are equal, good!
            if( part_to_match == c_part ) continue;

            // Check if the match is a variable
            let part_regexp_matches = part_to_match.match( /^\{(.*)\}$/ );
            if( part_regexp_matches ){
                // Does it have a condition?
                if( this._conditions[ part_regexp_matches[ 1 ] ] ){
                    // If the condition does not match, it can't be good...
                    if( !c_part.match( this._conditions[ part_regexp_matches[ 1 ] ] ) ) return false;
                }

                // If it reach here, we can add the value in the params object
                params[ part_regexp_matches[ 1 ] ] = c_part;
            }
        }

        this.params = params;

        return true;
    }
}

export default (new Router);



// WEBPACK FOOTER //
// ./resources/assets/js/framework/Router.js